import { styled } from '@mui/material';

import { tokens } from '../../../../theme/generated/tokens';
import { Button, ButtonProps, buttonVars } from '../../../buttons';

type TableActionButtonProps = ButtonProps & { disruptive?: boolean };

export const TableActionButton = styled(
  ({ children, ...rest }: TableActionButtonProps) => {
    return (
      <Button variant="ghost" size="sm" {...rest}>
        {children}
      </Button>
    );
  },
  {
    shouldForwardProp: (propName: PropertyKey) => propName !== 'disruptive',
  }
)(({ disruptive }) => [
  {
    background: tokens.theme.bg.structural.page,
    ':disabled': {
      background: tokens.theme.bg.structural.page,
    },
  },
  // TODO (Justas): cover with Design tokens
  disruptive && {
    ...buttonVars.setValues({
      color: tokens.primitives.colors.red[400],
      colorHover: tokens.primitives.colors.red[500],
      colorActive: tokens.primitives.colors.red[600],
      colorDisabled: tokens.primitives.colors.grey[300],
      background: tokens.primitives.colors.grey[100],
      backgroundHover: tokens.primitives.colors.red[50],
      backgroundActive: tokens.primitives.colors.red[100],
      backgroundDisabled: tokens.primitives.colors.grey[100],
      boxShadowHover: tokens.primitives.colors.red[500],
      boxShadowActive: tokens.primitives.colors.red[600],
    }),
  },
]);
